import { useRef, useState } from "react";
import { SlTab, SlTabGroup, SlTabPanel } from "@shoelace-style/shoelace/dist/react";
import SheetOnePreview from "./Sheet1/SheetOnePreview";
import SheetFourPreview from "./Sheet4/SheetFourPreview";
import SheetTwoPreview from "./Sheet2/SheetTwoPreview";
import SheetThreePreview from "./Sheet3/SheetThreePreview";
import NewBusinessDevelopment from "./NBD/NewBusinessDevelopment"; 
import SheetFivePreview from "./Sheet5/SheetFivePreview";
import ReviewReport from "./ReviewReports/reviewReport";
import FyPlanSummary from "./ReviewReports/FyPlanSummary";
import L2LRevenues from "./ReviewReports/L2LRevenues";
import ConvertedCustomers from "./ReviewReports/ConvertedCustomers";
import NonConvertedCustomers from "./ReviewReports/NonConvertedCustomers";
import ExclusiveW2NCustomers from "./ReviewReports/ExclusiveW2NCustomers";
import ComparisonReport from "./ReviewReports/ComparisonReport";
import CategoryWiseComparisonReport from "./CategoryWise/CategoryWiseComparisonReport";
const PhionexReports = () => {
  const tabGroupRef = useRef(null);
  const [activeTab, setActiveTab] = useState("sheet-1");

  return (
    <div className="p-4 font-sans">
      <SlTabGroup
        ref={tabGroupRef}
        onSlTabShow={(e) => {
          setActiveTab(e.detail.name);
        }}
      >
        <SlTab slot="nav" panel="sheet-1">Sheet 1</SlTab>
        <SlTab slot="nav" panel="sheet-2">Sheet 2</SlTab>
        <SlTab slot="nav" panel="sheet-3">Sheet 3</SlTab>
        <SlTab slot="nav" panel="sheet-4">Sheet 4</SlTab>
        <SlTab slot="nav" panel="sheet-5">Sheet 5</SlTab>
        <SlTab slot="nav" panel="category-wise">Category Wise Comparison</SlTab>
        <SlTab slot="nav" panel="nmd">New Business Development</SlTab>
        <SlTab slot="nav" panel="converted">Converted Customers</SlTab>
        <SlTab slot="nav" panel="non-converted">Non-Converted Customers</SlTab>
        <SlTab slot="nav" panel="exclusive-w2n">Exclusive W2N Customers</SlTab>
        <SlTab slot="nav" panel="review">Review Report</SlTab>
        <SlTab slot="nav" panel="plan">Fy Plan Summary</SlTab>
        <SlTab slot="nav" panel="l2l">L2L Revenues</SlTab>
        <SlTab slot="nav" panel="comparison">Comparison Reports</SlTab>
        <SlTabPanel name="sheet-1">
          {activeTab === "sheet-1" && <SheetOnePreview key="sheet-1" />}
        </SlTabPanel>
        <SlTabPanel name="sheet-2">
          {activeTab === "sheet-2" && <SheetTwoPreview key="sheet-2" />}
        </SlTabPanel>
        <SlTabPanel name="sheet-3">
          {activeTab === "sheet-3" && <SheetThreePreview key="sheet-3" />}
        </SlTabPanel>
        <SlTabPanel name="sheet-4">
          {activeTab === "sheet-4" && <SheetFourPreview key="sheet-4" />}
        </SlTabPanel>
        <SlTabPanel name="sheet-5">
          {activeTab === "sheet-5" && <SheetFivePreview key="sheet-5" />}
        </SlTabPanel>
        <SlTabPanel name="category-wise">
          {activeTab === "category-wise" && <CategoryWiseComparisonReport key="category-wise" />}
        </SlTabPanel>
        <SlTabPanel name="nmd">
          {activeTab === "nmd" && <NewBusinessDevelopment key="nmd" />}
        </SlTabPanel>
        <SlTabPanel name="converted">
          {activeTab === "converted" && <ConvertedCustomers key="converted" />}
        </SlTabPanel>
        <SlTabPanel name="non-converted">
          {activeTab === "non-converted" && <NonConvertedCustomers key="non-converted" />}
        </SlTabPanel>
        <SlTabPanel name="exclusive-w2n">
          {activeTab === "exclusive-w2n" && <ExclusiveW2NCustomers key="exclusive-w2n" />}
        </SlTabPanel>
        <SlTabPanel name="review">
          {activeTab === "review" && <ReviewReport key="review" />}
        </SlTabPanel>
         <SlTabPanel name="plan">
          {activeTab === "plan" && <FyPlanSummary key="plan" />}
        </SlTabPanel>
         <SlTabPanel name="l2l">
          {activeTab === "l2l" && <L2LRevenues key="l2l" />}
        </SlTabPanel>
        <SlTabPanel name="comparison">
          {activeTab === "comparison" && <ComparisonReport key="comparison" />}
        </SlTabPanel>
        
      </SlTabGroup>
    </div>
  );
};

export default PhionexReports;
